import { createModal } from '/@/core/elements/modal'
import type { ShortProjectInfo } from '/@/data/designer/types'

interface AddPortfolioProjectModalData {
  designerId: string
  nickname: string
  project: ShortProjectInfo | null
}
interface EditPortfolioProjectModalData {
  designerId: string
  nickname: string
  portfolioProjectId: string | null
}

const {
  api: useAddPortfolioProjectModal,
  component: AddPortfolioProjectModal,
} = createModal<AddPortfolioProjectModalData>(
  'AddPortfolioProjectModal',
  () => import('./AddPortfolioProjectModal.vue'),
  {
    designerId: '',
    nickname: '',
    project: null,
  },
)

const {
  api: useEditPortfolioProjectModal,
  component: EditPortfolioProjectModal,
} = createModal<EditPortfolioProjectModalData>(
  'EditPortfolioProjectModal',
  () => import('./EditPortfolioProjectModal.vue'),
  {
    designerId: '',
    nickname: '',
    portfolioProjectId: null,
  },
)

export {
  AddPortfolioProjectModal,
  useAddPortfolioProjectModal,
  EditPortfolioProjectModal,
  useEditPortfolioProjectModal,
}
